import { useEffect, useState } from 'react';
import { Search } from 'lucide-react';
import { api } from '@/lib/api';
import { ProductCard } from '@/components/ProductCard';

export default function Shop({ presale = false }) {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [active, setActive] = useState('All');
  const [search, setSearch] = useState('');

  const load = () => {
    const params = {};
    if (presale) params.presale = true;
    if (active !== 'All') params.category = active;
    if (search) params.search = search;
    api.get('/products', { params }).then(({ data }) => setProducts(data));
  };

  useEffect(() => { api.get('/categories').then(({ data }) => setCategories(['All', ...data])); }, []);
  useEffect(() => { load(); }, [active, search, presale]);

  return (
    <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-16 lg:py-24">
      <p className="eyebrow mb-3">{presale ? 'In Production' : 'The Collection'}</p>
      <h1 className="font-serif text-4xl lg:text-6xl mb-10">{presale ? 'Presale Atelier' : 'Maison Collection'}</h1>

      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 mb-12">
        <div className="flex flex-wrap gap-2">
          {categories.map((c) => (
            <button key={c} data-testid={`category-${c}`} onClick={() => setActive(c)}
              className={`px-4 py-2 text-xs font-mono uppercase tracking-wider border transition-colors ${active === c ? 'border-gold text-gold' : 'border-border text-muted-foreground hover:border-gold/50'}`}>
              {c}
            </button>
          ))}
        </div>
        <div className="relative w-full md:w-64">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input data-testid="shop-search-input" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search pieces…"
            className="w-full bg-surface border border-border pl-9 pr-4 py-2.5 text-sm outline-none focus:border-gold transition-colors" />
        </div>
      </div>

      {products.length === 0 ? (
        <p className="text-muted-foreground py-20 text-center">No pieces found in this selection.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
